import script from "./HrNotificationSettings.vue?vue&type=script&lang=ts&setup=true"
export * from "./HrNotificationSettings.vue?vue&type=script&lang=ts&setup=true"

import "./HrNotificationSettings.vue?vue&type=style&index=0&id=1ba04f04&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ba04f04"]])

export default __exports__